<template>

  <div>

    <iframe
        width="100%"
        height="300"
        style="border:0"
        :class="{'container-map-bordered':bordered}"
        loading="lazy"
        :allowfullscreen="showLink"
        referrerpolicy="no-referrer-when-downgrade"
        :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyD-HSv3BZv4lvYyCnjO0SZQlPU_if_JLl4&q='+latitude+','+longitude+'&zoom='+zoom">
    </iframe>

  </div>

</template>

<script>
export default {
  name: "t-map",
  data() {
    return {}
  },
  props: {
    latitude: {
      type: Number,
      default: 0
    },
    longitude: {
      type: Number,
      default: 0
    },
    showLink: Boolean,
    zoom: {
      type: [String, Number],
      default: 9
    },
    bordered: Boolean,
  },
  mounted() {

    this.setScale()

    if (this.subtitle !== "" || this.subtitle > 0) {
      this.localSubtitle = this.subtitle
    } else {
      this.localSubtitle = this.scale + "%"
    }


  },
  methods: {

    getLink() {

      const link = "https://www.openstreetmap.org/export/embed.html?bbox=" + this.longitude + "," + this.latitude + "," + this.longitude + "," + this.latitude + "&layer=mapnik&marker=" + this.latitude + "," + this.longitude

      //console.log(link)
      //console.log(encodeURI(link))

      return encodeURI(link)

    },

    setScale() {
      this.scale = (this.progress / this.total) * 100
    }

  }

}
</script>

<style>

</style>